<script setup>
import {onMounted, ref} from "vue";
import {router, usePage} from "@inertiajs/vue3";
import { trans } from 'laravel-vue-i18n';
import Quill from "quill";
import {Mention, MentionBlot} from "quill-mention";
import {getPrettyHTML} from "../../../../../helpers.js";

const status = ref(trans('forms.creating_form'));

const messages = usePage().props.messages;

const replace = [
    { id: 'salutation', value: trans('forms.mention_salutation') },
    { id: 'salutation_name', value: trans('forms.mention_salutation_name') },
    { id: 'salutation_surname', value: trans('forms.mention_salutation_surname') },
    { id: 'salutation_title', value: trans('forms.mention_salutation_title') },
    { id: 'register_date', value: trans('forms.mention_register_date') },
    { id: 'register_time', value: trans('forms.mention_register_time') },
    { id: 'name_surname', value: trans('forms.mention_name_surname') },
    { id: 'year', value: trans('forms.mention_year') },
    { id: 'todays_date', value: trans('forms.mention_todays_date') },
    { id: 'register_email', value: trans('forms.mention_register_email') },
    { id: 'register_phone', value: trans('forms.mention_register_phone') },
    { id: 'register_note', value: trans('forms.mention_register_note') },
    { id: 'custom_message', value: trans('forms.mention_custom_message') },
];

let quill_email = null;
let quill_sms = null;
let AlignStyle = Quill.import('attributors/style/align')
let BackgroundStyle = Quill.import('attributors/style/background')
let ColorStyle = Quill.import('attributors/style/color')
let DirectionStyle = Quill.import('attributors/style/direction')
let FontStyle = Quill.import('attributors/style/font')
let SizeStyle = Quill.import('attributors/style/size')

Quill.register({ "blots/mention": MentionBlot, "modules/mention": Mention });
Quill.register(AlignStyle, true);
Quill.register(BackgroundStyle, true);
Quill.register(ColorStyle, true);
Quill.register(DirectionStyle, true);
Quill.register(FontStyle, true);
Quill.register(SizeStyle, true);

onMounted(() => {
    quill_email = new Quill('#text1', {
        theme: 'snow',
        placeholder: trans('forms.quill_email_placeholder'),
        modules: {
            toolbar: [
                [{ 'font': [] }, { 'size': [] }],
                [ 'bold', 'italic', 'underline', 'strike' ],
                [{ 'color': [] }, { 'background': [] }],
                [{ 'script': 'super' }, { 'script': 'sub' }],
                [{ 'header': '1' }, { 'header': '2' }, 'blockquote' ],
                [{ 'list': 'ordered' }, { 'list': 'bullet'}, { 'indent': '-1' }, { 'indent': '+1' }],
                [ 'direction', { 'align': [] }],
                [ 'link', 'image', 'video', 'formula' ],
                [ 'clean' ]
            ],
            mention: {
                allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
                mentionDenotationChars: ["%"],
                source: function(searchTerm, renderList) {
                    if (searchTerm.length === 0) {
                        renderList(replace, searchTerm);
                    } else {
                        const matches = [];
                        for (let i = 0; i < replace.length; i++)
                            if (
                                ~replace[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())
                            )
                                matches.push(replace[i]);
                        renderList(matches, searchTerm);
                    }
                }
            }
        }
    });
    quill_sms = new Quill('#sms1', {
        theme: 'snow',
        placeholder: trans('forms.quill_sms_placeholder'),
        modules: {
            toolbar: false,
            mention: {
                allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
                mentionDenotationChars: ["%"],
                source: function(searchTerm, renderList) {
                    if (searchTerm.length === 0) {
                        renderList(replace, searchTerm);
                    } else {
                        const matches = [];
                        for (let i = 0; i < replace.length; i++)
                            if (
                                ~replace[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())
                            )
                                matches.push(replace[i]);
                        renderList(matches, searchTerm);
                    }
                }
            }
        }
    });
    if (messages.length) {
        messages.forEach(async (message) => {
            if(message.email_subject) {
                quill_email.setContents(JSON.parse(message.text_1))
                quill_sms.setContents(JSON.parse(message.sms_text_1))
                message.text_2 = getPrettyHTML(quill_email.container.firstChild.innerHTML);
                message.sms_text_2 = getPrettyHTML(quill_sms.container.firstChild.innerHTML).replace(/<[^>]*>/g, '');

                status.value = trans('forms.editing_email', { subject: message.email_subject })
                await save(message);
            }
        });
    }


    router.visit('/app/forms')
})


const save = async (m) => {
    m.go_back = true;
    await axios.post(`/app/notifications/${m.id}`,  m)
}
</script>

<template>
    <div class="w-full flex flex-col items-center gap-4 justify-center" style="height: calc(100vh - 105px)">
        <i class="pi pi-spin pi-spinner opacity-50" style="font-size: 3rem"></i>
        <p>{{status}}</p>
        <div class="hidden">
            <div class="hidden" id="text1"></div>
            <div class="hidden" id="sms1"></div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
